import { useFormik } from 'formik';
import { PqrReceivedThroughParamsDataProps } from './props';
import { useEffect } from 'react';
import { ISelect } from '../../../../../../shared/types/shared';

export const usePqrReceivedThroughData = ({
    data,
}: PqrReceivedThroughParamsDataProps) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            active: false,
            extra2: '',
            parent: '',
            alertFollowUp: '',
            alertProcessed: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active || false);
        formik?.setFieldValue('extra2', data?.extra2 || '');
        formik?.setFieldValue('parent', (data?.parent as ISelect)?.name || '');
        formik?.setFieldValue('alertFollowUp', data?.alertFollowUp || '');
        formik?.setFieldValue('alertProcessed', data?.alertProcessed || '');
    }, [data]);

    return {
        formik,
    };
};
